export default "__VITE_ASSET__7JF6p$Yu__"